/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RegisterRequestBody = {
  /**
   * The name of the org to register
   */
  orgName: string;
  /**
   * Optional partner signup code.
   */
  partnerCode?: string | undefined;
};

/** @internal */
export type RegisterRequestBody$Outbound = {
  org_name: string;
  partner_code?: string | undefined;
};

/** @internal */
export const RegisterRequestBody$outboundSchema: z.ZodMiniType<
  RegisterRequestBody$Outbound,
  RegisterRequestBody
> = z.pipe(
  z.object({
    orgName: z.string(),
    partnerCode: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      orgName: "org_name",
      partnerCode: "partner_code",
    });
  }),
);

export function registerRequestBodyToJSON(
  registerRequestBody: RegisterRequestBody,
): string {
  return JSON.stringify(
    RegisterRequestBody$outboundSchema.parse(registerRequestBody),
  );
}
